import React, { useState } from "react";
import { Link } from "react-router-dom";
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import ManageAccountIcon from 'assets/svg/ManageAccountIcon'
import LogoutIcon from 'assets/svg/LogoutIcon'
import { AccountContainer, MenuItemWrapper } from "styles/components/AccountDropDown";
import { useText } from "locales/useGetText";
import { useDispatch } from "react-redux";
import { setCountry } from "redux/actions/countrySelection";
import { getLocaleSelection } from "redux/reducers/countrySelection";

const AccountDropDown = () => {
  const loggedInUserInfo = JSON.parse(localStorage.getItem('loggedInUserData'))
  const locale = useText("nav");
  const dispatch = useDispatch();
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  const MenuItems = [
    {
      title: locale('manageAccount'),
      path: '/manage-account',
      cName: 'dropdown-link',
      type: 'ManageAccount'
    },
    {
      title: locale('logout'),
      path: '/',
      cName: 'dropdown-link-manageAccount',
      type: 'Logout'
    }
  ];

  const onLinkClick = (type) => {
    if (type === "Logout") {
      const rememberMe = localStorage.getItem("rememberMe");
      const email = localStorage.getItem("email");
      localStorage.clear();
      if (rememberMe !== null) {
        localStorage.setItem("email", email)
        localStorage.setItem("rememberMe", rememberMe)
      }
      dispatch(setCountry(getLocaleSelection()));
    }
  };

  return (
    <AccountContainer>
      <div className="avtar-style">
        <span>{loggedInUserInfo?.name?.substring(0, 1)}</span>
        <div className="wrapper-div">
          <p className="name">{loggedInUserInfo?.name}</p>
          <p className="email">{loggedInUserInfo?.email}</p>
        </div>
      </div>
      <hr />
      <ul
        onClick={handleClick}
        className={click ? 'dropdown-menu1 clicked' : 'dropdown-menu1'}
      >
        {MenuItems.map((item, index) => {
          return (
            <li key={index}>
              <Link
                className={item?.cName}
                to={item.path}
                onClick={() => onLinkClick(item?.type)}
              >
                <MenuItemWrapper>
                  {item.type === 'ManageAccount' && <ManageAccountIcon />}
                  {item.type === 'Logout' && <LogoutIcon />}
                  {item?.title}</MenuItemWrapper>
              </Link>
            </li>
          );
        })}
      </ul>
    </AccountContainer>
  );
};

export default AccountDropDown;
